import { SAlert } from './Alert.styles';
import { AlertProps } from './Alert.types';

export const Alert = ({ ...props }: AlertProps) => {
  return <SAlert {...props} />;
};
